import { chakra, Text, useBoolean, useToast } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { response_fixedAsset } from 'src/api'
import { fixedAssets } from 'src/api/models/fixedAssets'
import { useConfirmDialog } from 'src/components/common/Modals/ConfirmDialog'
import { useFixedAsset } from 'src/hooks/useFixedAsset'
import { PAGE_PATH } from 'src/routes'

export const useDeleteFixedAssetDialog = () => {
  const [isLoading, { on, off }] = useBoolean()
  const toast = useToast()
  const router = useRouter()
  const [currentAsset, setCurrentAsset] = useState<
    fixedAssets | response_fixedAsset | undefined
  >()
  const { deleteFixedAsset } = useFixedAsset(currentAsset?.id)
  const [renderDialog, methods] = useConfirmDialog()

  const onOpen = (asset: fixedAssets | response_fixedAsset) => {
    setCurrentAsset(asset)
    methods.onOpen()
  }

  const renderDeleteDialog = () =>
    renderDialog({
      header: `${currentAsset?.name}を削除`,
      body: (
        <>
          <Text
            fontSize="13px"
            lineHeight="20.8px"
            fontWeight={400}
            color="gray.800"
          >
            この固定資産を削除してよろしいですか？
            <br />
            <chakra.span color="primary.alert">
              この操作は取り消せないのでご注意ください。
            </chakra.span>
          </Text>
        </>
      ),
      okButton: {
        children: '削除',
        bgColor: 'primary.alert',
        color: 'white.100',
        isLoading,
        onClick: async () => {
          on()
          await deleteFixedAsset()
          router.replace(PAGE_PATH.fixed_assets.index)
          toast({
            status: 'success',
            title: `${currentAsset?.name || '固定資産'}を削除しました`
          })
          setCurrentAsset(undefined)
          off()
        }
      },
      cancelButton: {
        isLoading,
        children: 'キャンセル'
      }
    })

  return [renderDeleteDialog, { ...methods, onOpen }] as const
}
